var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseDataModifyButton,_vm._b({attrs:{"color":"success","small":""},on:{"click":function($event){return _setup.emit('click')}}},'BaseDataModifyButton',_setup.attrs,false),[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n        mdi-database-import\n    ")]),_vm._v("\n    Import\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }